export default __webpack_public_path__ + "static/media/animista.f7c515fc.webp";